import React, { Component } from 'react';
import './MileageFilter.css';
import { observer, inject } from 'mobx-react';

import { Icon, Slider } from 'antd';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class MileageFilter extends Component {
  keyStorage = `carFilter_mileage`;

  constructor(props) {
    super(props);

    let defaultState = {
      visible: false,
      minMileage: 0,
      maxMileage: 0,
      selectedMinMileage: null,
      selectedMaxMileage: null,
      mileage: []
    };
    const { filterStore } = this.props;
    let { selectedMinMileage, selectedMaxMileage } = filterStore.appliedFiltersParameters[this.keyStorage] || {};
    if (selectedMinMileage !== undefined && selectedMaxMileage !== undefined) {
      const mileage = [selectedMinMileage, selectedMaxMileage];
      defaultState = { ...defaultState, mileage, selectedMinMileage, selectedMaxMileage };
    }
    this.state = defaultState;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  changeMileage = mileage => {
    this.setState({ mileage: [mileage[0] || this.props.carsStore.totalMilMin, mileage[1] || this.props.carsStore.totalMilMax] }, () => {
      this.setState({ selectedMinMileage: this.state.mileage[0], selectedMaxMileage: this.state.mileage[1] });
    });
  };

  changeFilter = () => {
    const { mileage } = this.state;
    const { filterStore } = this.props;
    if (mileage) {
      filterStore.add('carFilter_mileage', car => {
        const _mileage =
          car.odometer && car.odometer.value > 0 ? car.odometer.value : car.gpsOdometer && car.gpsOdometer.value > 0 ? car.gpsOdometer.value + car.initialOdometer : -1;
        return _mileage >= mileage[0] && _mileage <= mileage[1] && _mileage > -1;
      }, undefined, {
        selectedMinMileage: mileage[0],
        selectedMaxMileage: mileage[1]
      });
    } else {
      filterStore.remove('carFilter_mileage');
    }
  };

  removeMileage = () => {
    const { filterStore } = this.props;
    this.setState({ selectedMinMileage: null, selectedMaxMileage: null, mileage: undefined });
    filterStore.remove('carFilter_mileage');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        minMileage: 0,
        maxMileage: 0,
        selectedMinMileage: null,
        selectedMaxMileage: null,
        mileage: []
      });
    }
  };
  //dobbiamo usare entrambe le callback, onBeforeChange e onAfterChange, x https://github.com/react-component/slider/issues/529
  render() {
    const { selectedMinMileage, selectedMaxMileage, mileage } = this.state;
    const { translationsStore, carsStore } = this.props;
    return (
      <div id="mileageFilter" className="MileageFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.mileage')}
          {Number.isInteger(selectedMinMileage) && (
            <span>
              {selectedMinMileage} - {selectedMaxMileage}
              <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeMileage} />
            </span>
          )}
        </div>
        <Slider
          disabled={carsStore.totalMilMin === carsStore.totalMilMax}
          value={mileage || [carsStore.totalMilMin, carsStore.totalMilMax]}
          onChange={this.changeMileage}
          onBeforeChange={this.changeFilter} //https://github.com/react-component/slider/issues/529 -> when the bug get close we have to use onAfterChange. onBeforeChange is not documented in antd Slider
          onAfterChange={this.changeFilter} //https://github.com/react-component/slider/issues/529 -> when the bug get close we have to use onAfterChange. onBeforeChange is not documented in antd Slider
          tipFormatter={null}
          range
          step={1000}
          min={carsStore.totalMilMin}
          max={carsStore.totalMilMax}
          marks={{
            [carsStore.totalMilMin]: {
              style: {
                color: '#f50'
              },
              label: `${carsStore.totalMilMin} km`
            },
            [carsStore.totalMilMax]: {
              style: {
                color: '#f50'
              },
              label: (
                <div>
                  <span>{carsStore.totalMilMax}</span>
                  <span>&nbsp;km</span>
                </div>
              )
            }
          }}
        />
      </div>
    );
  }
}
